import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=1c8b44ab&scoped=true&"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDropdown.vue?vue&type=style&index=0&id=1c8b44ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b44ab",
  null
  
)

export default component.exports